module.exports = __webpack_public_path__ + "img/f_ic_data.624fbf81.svg";